import { render } from "./CostSettingsTable.vue?vue&type=template&id=8a31d864&scoped=true&ts=true"
import script from "./CostSettingsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CostSettingsTable.vue?vue&type=script&setup=true&lang=ts"

import "./CostSettingsTable.vue?vue&type=style&index=0&id=8a31d864&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a31d864"],['__file',"resources/js/vue/domain/admin/seg-frame-builder/CostSettingsTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8a31d864"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8a31d864', __exports__)) {
    api.reload('8a31d864', __exports__)
  }
  
  module.hot.accept("./CostSettingsTable.vue?vue&type=template&id=8a31d864&scoped=true&ts=true", () => {
    api.rerender('8a31d864', render)
  })

}


export default __exports__